import CheckBoxSelectionProcessor from '../../Components/Core/Processors/CheckboxSelectionProcessor'
import CheckBoxSelectionResultProcessor from '../../Components/Core/SelectionResults/CheckBoxSelectionResultProcessor'
import ExactaValidator from '../../Validation/ExactaValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class ExactaConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'Exacta',
      name: 'Exacta',
      supportsFlexi: true,
      sortOptions: ['Number', 'FixedPrice', 'Price'],
      template: 'exacta-template',
      betSelectionTemplate: 'dual-checkbox-selection-template',
      multiBet: false,
      multiSelections: true,
      checkBoxCount: 2,
      fieldCheckBoxCount: 2,
      sameAsCheckBoxCount: 1,
      processor: new CheckBoxSelectionProcessor(2),
      selectionResultProcessor: new CheckBoxSelectionResultProcessor(2),
      validator: new ExactaValidator(),
      legs: 1,
    })
  }
}
